// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"1e6929ffcb59d983","777":"8363dbdbe241332f"}[chunkId] + ".js";
};